import type { ReactNode } from 'react';
import DeferRenderUntilIntersecting from '@/components/DeferRenderUntilIntersecting';
import PageAnchor from '@/components/PageAnchor';
import { Container, Title, Description } from './styled';

interface Props {
  title: string;
  description: string;
  anchor?: string;
  isDeferred?: boolean;
  preRenderHeight?: number | string;
  preRenderHeightMdDown?: number | string;
  preRenderHeightSmDown?: number | string;
  children: ReactNode;
}

const Widget = ({
  title,
  description,
  anchor,
  children,
  isDeferred,
  preRenderHeight,
  preRenderHeightMdDown,
  preRenderHeightSmDown,
}: Props) => (
  <Container data-cy-id={anchor}>
    {anchor && <PageAnchor id={anchor} />}
    <Title>{title}</Title>
    <Description>{description}</Description>
    {isDeferred ? (
      <DeferRenderUntilIntersecting
        preRenderHeight={RUNTIME_ENV === 'server' ? preRenderHeight : undefined}
        preRenderHeightMdDown={
          RUNTIME_ENV === 'server' ? preRenderHeightMdDown : undefined
        }
        preRenderHeightSmDown={
          RUNTIME_ENV === 'server' ? preRenderHeightSmDown : undefined
        }
        skipDefer={RUNTIME_ENV === 'server' || !!window.location.hash}
      >
        {() => children}
      </DeferRenderUntilIntersecting>
    ) : (
      children
    )}
  </Container>
);

export default Widget;
